import lodash from 'lodash';
import { useEffect, useMemo, useState } from 'react';

import { MIN_DEBOUNCE_TIME } from 'constants/appConstants';

type DebouncedSetter = ((nextCode: string) => void) & { cancel: () => void };

export const useDebounce = (): [string, DebouncedSetter] => {
  const [code, setCode] = useState('');

  const debounceFunction = useMemo<DebouncedSetter>(() => {
    const debounced = lodash.debounce((nextCode: string) => {
      setCode(nextCode);
    }, MIN_DEBOUNCE_TIME);

    return debounced as DebouncedSetter;
  }, []);

  useEffect(() => {
    return () => {
      debounceFunction.cancel();
    };
  }, [debounceFunction]);

  return [code, debounceFunction];
};
